import { t } from '@lingui/core/macro';
import { TFile } from 'components/Signup/hooks/useFileUploadReducer';
import { TFileStatusGroup } from 'types';

export const renderDocumentText = ({
  files,
  statusGroup,
}: {
  files: TFile[];
  statusGroup: TFileStatusGroup;
}) => {
  if (files.length > 1) {
    if (statusGroup === 'approved') {
      return t`Documents approved`;
    }
    if (statusGroup === 'rejected') {
      return t`Documents rejected`;
    }
    return t`Documents uploaded`;
  }

  if (statusGroup === 'approved') {
    return t`Document approved`;
  }
  if (statusGroup === 'rejected') {
    return t`Document rejected`;
  }
  return t`Document uploaded`;
};
